export default (text) => {
  return typeof text == 'string' ? text.replace(/ /gi, '-') : text;
};
